import cx from 'classnames'
import type React from 'react'

import IconInputCheck from '../../../../icons/IconInputCheck'
import Badge from '../../../Badge/Badge'
import css from './Option.module.scss'

type Props = {
  value: string | number
  icon?: React.ReactNode
  successIcon?: boolean
  rightText?: string
  badgeType?: string | null
  disabled?: boolean
  danger?: boolean
  selected: boolean
  onClick: (value: string | number) => void
  children?: React.ReactNode
}

const Option: React.FC<Props> = ({
  onClick,
  value,
  icon,
  successIcon,
  rightText,
  children,
  badgeType,
  disabled = false,
  danger = false,
  selected,
  ...props
}) => {
  const handleOnClick = () => {
    if (!disabled) {
      onClick(value)
    }
  }

  const handleBadgeClick = () => {
    if (badgeType && disabled) {
      onClick(value)
    }
  }

  return (
    <div
      className={cx(css.container, {
        [css.disabled]: disabled,
        [css.danger]: danger,
        [css.selected]: selected,
      })}
      onClick={handleOnClick}
      {...props}
    >
      <div className={css.label}>
        {icon && <div className={css.icon}>{icon}</div>}

        <div className={css.text}>{children}</div>
      </div>

      {rightText && !badgeType && (
        <div className={css.rightText}>{rightText}</div>
      )}

      {badgeType && !rightText && (
        <Badge type={badgeType} onClick={handleBadgeClick} />
      )}

      {successIcon && (
        <div className={css.successIcon}>
          <IconInputCheck color="#18C4A9" />
        </div>
      )}
    </div>
  )
}

export default Option
